import { render, staticRenderFns } from "./EditLanguage.vue?vue&type=template&id=79e7c30c&scoped=true&"
import script from "./EditLanguage.vue?vue&type=script&lang=js&"
export * from "./EditLanguage.vue?vue&type=script&lang=js&"
import style0 from "./EditLanguage.vue?vue&type=style&index=0&id=79e7c30c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e7c30c",
  null
  
)

export default component.exports